import { useEffect } from "react";
import { BRAND } from "@/lib/brand";
import { canonicalPath } from "@/lib/seoPages";

// Lightweight, dependency-free per-page SEO. Sets <title>, description,
// canonical and Open Graph / Twitter tags on mount. Works with client-side
// rendering today and is captured correctly by prerendering tools later.
function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "", image }) {
  const fullTitle = title ? `${title} | ${BRAND.name}` : BRAND.defaultTitle;
  const desc = description || BRAND.description;
  const url = BRAND.url + canonicalPath(path);
  const img = image || BRAND.ogImage;

  useEffect(() => {
    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);

    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", img);
  }, [fullTitle, desc, url, img]);

  return null;
}
